/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";
import AddressInfoDisplay, { AddressInfoDisplayStyles } from "@insite/content-library/Components/AddressInfoDisplay";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { warehouseNameStyle, warehouseWrapper } from "@monsma/XDL/Utilities/sharedStyles";
import React from "react";
import { css } from "styled-components";

interface OwnProps {
    warehouse: WarehouseModel;
    extendedStyles?: WarehouseAddressInfoDisplayStyles;
}
// xng-change: adding wrapper style key and its style needed
export interface WarehouseAddressInfoDisplayStyles {
    wrapper?: InjectableCss;
    warehouseNameText?: TypographyPresentationProps;
    address?: AddressInfoDisplayStyles;
}

export const warehouseAddressInfoDisplayStyles: WarehouseAddressInfoDisplayStyles = {
    wrapper: {
        css: css`
            ${warehouseWrapper}
        `,
    },
    warehouseNameText: warehouseNameStyle,
};

const WarehouseAddressInfoDisplay = ({ warehouse, extendedStyles }: OwnProps) => {
    const [styles] = React.useState(() => mergeToNew(warehouseAddressInfoDisplayStyles, extendedStyles));
    return (
        //  xng-change: adding a wrapper
        <StyledWrapper {...styles.wrapper}>
            <Typography as="p" {...styles.warehouseNameText}>
                {warehouse.description || warehouse.name}
            </Typography>
            <AddressInfoDisplay {...warehouse} extendedStyles={styles.address} />
        </StyledWrapper>
    );
};

export default WarehouseAddressInfoDisplay;
